<template>
  <div
    class="tab-container"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <div class="tabs engLish_tabs wow hidden-xs-only animate__animated animate__fadeInRight">
      <div
        class="za_tab-item eng_tab-item"
        :class="selectedIndex === index ? 'zangselected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.englishName }}</div>
      </div>
    </div>
    <div
      class="mobile_tabs wow hidden-sm-and-up animate__animated animate__fadeInRight"
    >
      <div
        class="tab-item eng_tab-item eng_tab-item-mobile"
        :class="selectedIndex === index ? 'selected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.englishName }}</div>
      </div>
    </div>
  </div>
  <div class="tab-container" v-else-if="this.language == 'en'">
    <div class="tabs zang_tabs wow hidden-xs-only animate__animated animate__fadeInRight">
      <div
        class="za_tab-item"
        :class="selectedIndex === index ? 'zangselected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.zaName }}</div>
        <!-- <div v-html="item.zangName"></div> -->
      </div>
    </div>
    <!-- 手机 -->
    <div
      class="mobile_tabs wow hidden-sm-and-up animate__animated animate__fadeInRight"
    >
      <div
        class="tab-item za_tab-item za_tab-item-mobile"
        :class="selectedIndex === index ? 'selected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.zaName }}</div>
      </div>
    </div>
  </div>
  <div class="tab-container" v-else>
    <div class="tabs wow hidden-xs-only animate__animated animate__fadeInRight">
      <div
        class="tab-item tab-items"
        :class="selectedIndex === index ? 'selected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div
      class="mobile_tabs wow hidden-sm-and-up animate__animated animate__fadeInRight"
    >
      <div
        class="tab-item cn_tab-item"
        :class="selectedIndex === index ? 'selected' : ''"
        v-for="(item, index) in tabNames"
        :key="index"
        @click="onTabClick(index)"
      >
        <div>{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  props: {
    tabNames: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  data() {
    return {
      language: this.$store.state.language,
      selectedIndex: 0,
      MessagesList: [
        {
          title: "热贡唐卡",
          za_title: " རེབ་གོང་ཐང་ག",
          eng_title: "Regong Thangka",
          introduce:
            "藏式卷轴画（藏语译音为唐卡），是一种便于悬挂，易于收藏的画种，用彩缎装裱而成。这种画具有鲜明的民族特点，浓郁的宗教色彩和独特的艺术风格，历来被藏族人民视为珍宝。热贡地区的唐卡题材以佛教内容为主，绘画技巧上一般采用单线平涂略加烘染和色块填勾的手法，构图采用散点透视的方法。画面上的神、佛、山水、花草、楼台亭阁、鸟兽等都活灵活现、逼真生动且色彩鲜艳。热贡唐卡画人物形象精而有神，栩栩如生；写走兽花鸟，则精于勾勒，注意设色，姿态生动，配奇石山景，峰峦叠嶂，气势雄伟；绘宫殿楼阁，格调稳重，布置壮丽。在取景布局上视野广阔，不受时间、空间的局限，把同一主题而发生在不同时间、地点的事物组合在一起，使画面有咫尺千里之感，具有较强的感染力。热贡唐卡技巧独到、别具一格，成为藏画艺术的一种典范。",
          eng_introduce:
            "Tibetan scroll painting (pronounced Thangka in Tibetan) is a type of painting that is easy to hang and collect, and is made by mounting colorful silk onto a frame. This type of painting has a distinct ethnic flavor, rich religious colors, and a unique artistic style. It has always been regarded as a treasure by the Tibetan people. The subject matter of Thangka in the Regong area is mainly Buddhist content. The painting technique generally uses a single-line flat coating with a slight shading and color block filling technique, and the composition uses a scattered perspective method. The gods, Buddhas, mountains, rivers, flowers, buildings, pavilions, and birds and beasts on the painting are all vivid, lifelike, and brightly colored. The figures in the Regong Thangka are exquisite and divine, and come to life; the animals, flowers and birds are finely delineated, with attention paid to color, vivid postures, and paired with strange rocks, mountain scenery, towering peaks, and majestic momentum; the palaces and pavilions are elegant and magnificent in style. In terms of perspective, the scope is broad and not limited by time and space. It combines elements of the same theme that occur in different times and places, giving the painting a sense of being close yet far, and has strong emotional appeal. Regong Thangka has unique techniques and a distinctive style, becoming a model of Tibetan painting art.",
          za_introduce:
            "ཐང་ག་ནི་འགེལ་བདེ་བ་དང་ཉར་ཚགས་བྱེད་སླ་པའི་རི་མོའི་རྣམ་པ་ཞིག་ཡིན། དེ་ནི་གོས་ཆེན་གྱི་གོང་གཤམ་སྤྲད་ནས་གྲུབ་པ་ཞིག་གོ །དེ་ལ་མི་རིགས་ཀྱི་ཁྱད་ཆོས་མངོན་གསལ་དོད་པོ་ཡོད་ལ། ཆོས་ལུགས་ཀྱི་ཁྱད་ཆོས་དང་ཐུན་མོང་མ་ཡིན་པའི་སྒྱུ་རྩལ་གྱི་ཉམས་ཀྱིས་ཕྱུག་པས་སྔ་མོ་ནས་བོད་རིགས་མི་དམངས་ཀྱིས་གཅེས་ནོར་དུ་བརྩི་གི་ཡོད། རེབ་གོང་ས་ཁུལ་གྱི་ཐང་ག་ནི་ཆོས་ལུགས་ཀྱི་བརྗོད་བྱ་གཞིར་བྱས་ཤིང་། འབྲི་ཐབས་ལ་སྤྱིར་བཏང་དུ་རྐྱང་ཐིག་སྙོམས་འབྱུག་དང་། མདངས་ཅུང་ཟད་དབྱུང་བ་དང་། ཚོན་མདངས་སྣོན་པའི་ཐབས་སྤྱོད་པ་ཞིག་ཡིན། རི་མོའི་མཚོན་བྱ་བཀོད་སྒྲིག་བྱེད་པ་ལ་ཐོར་སྣེ་མཐོང་སྒྲིབ་ཀྱི་ཐབས་བཀོལ་བ་ཡིན། པར་ངོས་ཀྱི་ལྷ་དང་རི་ཆུ། རྩི་ཤིང་མེ་ཏོག ། ལྡིང་ཁང་།  བྱ། རི་དྭགས་སོགས་བྲིས་པ་གསོན་ཉམས་ལྡན་ལ་ཚོན་མདངས་རྣམ་པར་བཀྲ། རེབ་གོང་ཐང་ཀའི་ཁྲོད་ཀྱི་མི་སྣའི་སྣང་བརྙན་ནི་གསོན་ཉམས་ལྡན་ལ་མཛེས་ཉམས་ཆེ། མེ་ཏོག་དང་། འདབ་ཆགས། སྲོག་ཆགས་སོགས་འབྲི་བཞེངས་བྱེད་སྐབས་རགས་བྲིས་ཀྱི་ཐབས་བཀོལ་སྤྱོད་བྱེད། ཚོན་རྒྱག་སྟངས་ཀྱི་ཐད་ལ་གསོན་ཉམས་ལྡན་པ་ཞིག་ཏུ་འབྲི་བཞེངས་བྱེད་པར་དོ་སྣང་ཆེ། ངོ་མཚར་བའི་རི་བྲག་གི་མཛེས་ལྗོངས་དང་རི་རྩེའི་མུ་ཁྱུད་སོགས་ལ་བརྗིད་ཆགས་ཤིང་མཛེས་ཉམས་དོད། ཡུལ་ལྗོངས་འབྲི་བཞེངས་བྱེད་སྐབས་མཐོངས་ཡངས་ཤིང་།གནས་དུས་ཀྱི་བཀག་རྒྱ་མེད་པར་བརྗོད་བྱ་གཅིག་པའི་བྱ་དངོས་དག་ཕྱོགས་གཅིག་ཏུ་བསྡུས་ཏེ། ཚོར་འདུ་དྲག་པོ་པར་ངོས་གཅིག་ཏུ་འཐོན་པར་བྱེད། རེབ་གོང་གི་ཐང་ག་འབྲི་བཞེངས་ལ་ཐུན་མོང་མ་ཡིན་པའི་ཁྱད་ཆོས་ལྡན་པས་བོད་ཀྱི་རི་མོའི་སྒྱུ་རྩལ་གྱི་དཔེ་མཚོན་དུ་གྱུར་ཡོད།",
          worksImages: [
            {
              imgSrc: require("../assets/newImage/index/tangka01.png"),
              name: "十八罗汉",
              za_name: "གནས་བརྟན་བཅོ་བརྒྱད།",
              eng_name: "The four-armed Avalokitesvara",
            },
            {
              imgSrc: require("../assets/newImage/index/tangka02.png"),
              name: "四臂观音",
              za_name: "སྤྱན་རས་གཟིགས་ཕྱག་བཞི་པ།",
              eng_name: "The four-armed Avalokitesvara",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
        {
          title: "热贡堆绣",
          za_title: "རེབ་གོང་",
          eng_title: "Regong Embroidery",
          eng_introduce:
            "Stacking embroidery is a special art that uses techniques such as 'cutting' and 'stacking' to shape images. From a technical perspective, it can be further divided into 'cutting pile' and 'embroidery'. Regong embroidery mainly focuses on cutting and stacking. When making pile embroidery, the artist selects various colors of silk and satin according to the content expression needs, cuts them into certain sizes of figures, animals, flowers, birds, etc., and uses colored silk and satin to stick and press them onto the pre cut paper pattern. Then, the colors are stacked in order from thick to light. The material selection of pile embroidery emphasizes the shape and demeanor of the characters, and emphasizes the configuration of various colors of silk and satin. It is rough and delicate, and due to the prominent, bright colors, and strong contrast of the main Buddha statue, it creates a strong sense of three-dimensional, like a silk colored relief. Regong embroidery is an innovation in embroidery art and a combination of embroidery and relief. A pile of embroidery is a silk colored relief.",
          za_introduce:
            "དྲས་དྲུབ་ནི'གཏུབ་པ'དང'མཐུད་པ'འི་ལག་རྩལ་ལ་བརྟེན་ནས་གཟུགས་བརྙན་གསར་བཞེངས་བྱེད་པའི་དམིགས་བསལ་གྱི་སྒྱུ་རྩལ་ཞིག་རེད། ལག་རྩལ་གྱི་སྟེང་ནས་དབྱེ་ན་དེ་ཡང་དྲས་གཏུབ་དང་ཚེམ་དྲུབ་གཉིས་སུ་ཕྱེ་ཆོག ། རེབ་གོང་སྟོད་ཁུལ་གྱི་དྲས་དྲུབ་ནི་གཙོ་བོ་དྲས་ཕུང་གཙོ་བོར་བྱེད་པ་དང་། དྲས་དྲུབ་བཟོ་སྐབས་སྒྱུ་རྩལ་པས་ནང་དོན་གྱི་དགོས་མཁོར་གཞིགས་ནས་ཁ་དོག་སྣ་ཚོགས་ཀྱི་དར་གོས་རིང་ཐུང་ངེས་ཅན་ལྡན་པའི་མི་སྣ་དང་། རི་དྭགས། མེ་ཏོག །འདབ་ཆགས་སོགས་སུ་གཏུབ་པ་དང་། དེ་སྔོན་ལ་དྲས་ཟིན་པའི་ཤོག་བུའི་དཔེ་དབྱིབས་ཐོག་སྦྱར་རྗེས་ཁ་དོག་གསལ་པོ་ནས་སྐྱ་བོར་གྱུར་སྐབས་རིམ་བཞིན་སྦྱར་དགོས། དྲས་དྲུབ་ཀྱི་བརྗོད་བྱ་འདེམ་པར་མི་སྣའི་བཟོ་དབྱིབས་དང་རྣམ་འགྱུར་ལ་དོ་སྣང་བྱེད་དགོས་པ་མ་ཟད། ཁ་དོག་ཀྱི་སྡེབ་ཁ་ལ་ཡང་དོ་སྣང་བྱེད་དགོས། སྟབས་བདེ་ལས་ཞིབ་ཆ་མཐོང་ཐུབ་ལ། སྐུ་འདྲ་གཙོ་བོ་འབུར་དུ་ཐོན་པ་དང་། ཚོན་མདངས་རྣམ་པར་བཀྲ་ལ། ཕན་ཚུན་བསྡུར་རུང་དྲག་པོ་ཡོད་རྐྱེན་འབུར་གཟུགས་ཀྱི་ཚོར་བ་ཅུང་དྲག་པས་དར་སྐུད་ཀྱི་ཚོན་ལྡན་འབུར་བརྐོས་ཤིག་དང་ཡང་འདྲ། རེབ་གོང་གི་དྲས་དྲུབ་དང་། འཚེམ་དྲུབ་ནི་དྲས་དྲུབ་སྒྱུ་རྩལ་གྱི་གསར་གཏོད་ཅིག་ཡིན་ལ། ཚེམ་དྲུབ་དང་འབུར་བརྐོས་ཟུང་འབྲེལ་བྱས་ཡོད། དྲས་དྲུབ་ཀྱི་ཐང་ག་ནི་དར་སྐུད་ཀྱི་ཚོན་ལྡན་འབུར་བཟོ་ཞིག་ཡིན་པར་ཡང་བཤད་ཆོག །",
          introduce:
            "堆绣是一种运用“剪”、“堆”技法塑造形象的特殊的艺术。从技法上区分，它又分为“剪堆”和“刺绣”。热贡堆绣主要以剪堆为主。堆绣制作时，艺人根据内容表达需要选好种种颜色的绸缎，剪成一定尺寸的人物、走兽、花鸟等，用彩色绸缎粘压在事先剪好的纸张模式上，然后让颜色从浓到淡，依次粘堆。堆绣的取材注重人物的造型和神态，讲究各色绸缎的配置，粗犷中见细腻，由于主体佛像突出、色彩鲜艳、对比强烈，产生较强的立体感，犹如一幅丝质的彩色浮雕。热贡堆绣，是刺绣艺术的创新，是刺绣与浮雕的结合。一幅堆绣就是一幅丝质的彩色浮雕。",
          worksImages: [
            {
              imgSrc: require("../assets/newImage/index/duixiu01.png"),
              name: "藏传佛教吉祥八宝之金轮",
              za_name: "འཁོར་ལོ།",
              eng_name: "The Golden Wheel of the Eight Auspicious Treasures in Tibetan Buddhism",
            },
            {
              imgSrc: require("../assets/newImage/index/duixiu02.png"),
              name: "藏传佛教吉祥八宝之宝伞",
              za_name: "གདུགས།",
              eng_name: "The Treasure Umbrella of the Eight Auspicious Treasures in Tibetan Buddhism",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
        {
          title: "热贡泥塑",
          za_title: " ར་གོང་འཇིམ་བཟོ།",
          eng_title: "Regong Sculpture",
          eng_introduce:
            "Tongren County, located in Huangnan Tibetan Autonomous Prefecture, Qinghai Province, is known as the 'hometown of Regong art'. In 2009, the Regong clay sculpture, along with the Regong Thangka and Regong embroidery, were included in the UNESCO Intangible Cultural Heritage List under the name of 'Regong Art'. The production of Regong clay sculpture requires complex processes such as soil selection, mud smashing, sculpture, plastering, coloring, and gold painting. The main components of the Regong clay sculpture are red earth and medicinal powder, as well as the addition of jewelry such as coral and pearls, as well as a small amount of cotton. The Regong clay sculpture is mainly composed of Buddhist figures, with perfect and vivid shapes and vivid expressions. The clothing pleats are both concise and smooth, rich in texture, exquisite and transparent, elegant and generous, with strong color contrast and vibrant coordination. In addition to using sun, moon, stars, mountains, rivers, plants, birds, animals, fish, and insects as decorative patterns and accessories, various shapes are also created based on Buddhist stories and classics.",
          za_introduce:
            "མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་བོད་རིགས་རང་སྐྱོང་ཁུལ་གྱི་ཐུན་རིན་རྫོང་ལ'རེབ་གོང་སྒྱུ་རྩལ་གྱི་ཕ་ས'ཞེས་པའི་མཚན་སྙན་ཐོབ་ཡོད། 2009ལོར་རེབ་གོང་གི་འཇིམ་བཟོ་དང་ཐང་ག །འཚེམ་དྲུབ་སོགས་ལ'རེབ་གོང་སྒྱུ་རྩལ'་གྱི་མིང་ཐོག་ནས་མཉམ་འབྲེལ་རྒྱལ་ཚོགས་སློབ་གསོ་ཚན་རིག་རིག་གནས་སྒྲིག་འཛུགས་ཀྱིས་གཟུགས་མེད་ཤུལ་བཞག་རིག་གནས་ཀྱི་མིང་བསྩལ། རེབ་གོང་འཇིམ་བཟོ་བཟོ་བར་ས་རྒྱུ་འདེམས་པ་དང་། འདམ་གཅོག་པ། གཟུགས་སུ་འཆོས་པ།  གསེར་རྩི་འབྱུག་པ་སོགས་རྙོག་འཛིང་ཆེ་བའི་ལས་རིམ་སྣ་ཚོགས་བརྒྱུད་དགོས། རེབ་གོང་འཇིམ་བཟོའི་གྲུབ་ཆ་གཙོ་བོ་ནི་ས་དམར་དང་སྨན་ཕྱེ་ཡིན་ལ། ད་དུང་བྱུ་རུ་དང་མུ་ཏིག་སོགས་རིན་པོ་ཆེ་ཡོད་པར་མ་ཟད། སྲིང་བལ་ཉུང་ཤས་སོགས་ཀྱང་སྣོན་དགོས། རེབ་གོང་འཇིམ་བརྙན་ནི་སངས་རྒྱས་ཆོས་ལུགས་ཀྱི་སྐུ་བརྙན་གཙོ་བོ་ཡིན་པ་དང་། བཟོ་དབྱིབས་ཕུན་སུམ་ཚོགས་ཤིང་གསོན་ཉམས་ལྡན། མནབ་བཟའི་ལྟེབ་གཉེར་སོགས་སྟབས་བདེ་ཞིང་ཟོར་ཡངས་པར་མ་ཟད། སྤུས་ཚད་དང་བཟོ་བཀོད་གང་ཡིན་ཀྱང་ཡིད་དུ་འོང་། དེ་མིན་ཚོན་གྱི་མདངས་ལ་བཀྲག་མདངས་འཚེར་བ་སོགས་ཀྱི་ཁྱད་ཆོས་ཀྱང་ལྡན། ཉི་ཟླ་སྐར་གསུམ། རི་ཀླུང་དང་རྩི་ཤིང་། འདབ་ཆགས། རི་དྭགས། ཉ་འབུ་སོགས་རྒྱན་རིས་དང་རྒྱན་སྤྲས་དངོས་པོ་བྱས་ཡོད་པ་ཕུད། ནང་བསྟན་གྱི་གཏམ་རྒྱུད་དང་བསྟན་བཅོས་ཁག་གཙོར་གཞིར་བཟུང་ནས་བཟོ་དབྱིབས་འདྲ་མིན་སྣ་ཚོགས་གསར་བཟོ་བྱས་ཡོད།",
          introduce:
            "位于青海省黄南藏族自治州的同仁县有着“热贡艺术之乡”的美誉。2009年，热贡泥塑与热贡唐卡、热贡堆绣等以“热贡艺术”的名义被列入联合国教科文组织非物质文化遗产名录。热贡泥塑的制作要经过选土、砸泥、雕塑、抹压、上色描金等复杂的工序。热贡泥塑的主要成分是红土和药粉，还要添加珊瑚、珍珠等珠宝，以及少量的棉花等。热贡泥塑塑像以佛教人像为主，造型完美生动，神态刻画惟妙惟肖，服饰衣褶既简练流畅，又富于质感，既玲珑剔透，又典雅大方，色彩对比强烈而又鲜艳协调。除日月星辰、山川草木、鸟兽鱼虫等作为装饰纹样和陪衬饰物外，还根据佛教故事和典籍创作出各种各样的造型。",
          worksImages: [
            {
              imgSrc: require("../assets/newImage/index/nisu01.png"),
              name: "吉祥四瑞",
              za_name: "མཐུན་པ་སྤུན་བཞི།",
              eng_name: "Four Auspicious Animals(The picture shown is located in Renjunyuan)",
            },
            {
              imgSrc: require("../assets/newImage/index/nisu02.png"),
              name: "夏吾角大师在制作泥塑",
              za_name: "སློབ་དཔོན་ཆེན་མོ་ཤ་བོ་རྒྱལ་གྱིས་འཇིམ་བཟོའི་རྣམ་པ།",
              eng_name: "Master Xia Wu Jiao is making clay sculptures",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
        {
          title: "热贡壁画",
          za_title: " ར་གོང་ལྡེབས་རིས།",
          eng_title: "Regong Murals",
          eng_introduce:
            "Around the 14th century AD, Tibetan Buddhism began to spread in Tongren. After the 15th century, with the rapid development of the Sakya Sect, followed by the Gelug Sect [Yellow Sect], monasteries were flourishing in various regions, so that a large number of Tibetan and Tu monks and customs were involved in the activities of painting statues and decorating temples. Therefore, a large number of beautiful murals, embroidery, Thangka, architectural painting and other hot tribute works of art were also preserved in each temple. Among them, the Qing Dynasty mural 'Biography of the Sixteen Arhats' in Maitreya Hall of Nianduhu Temple (3.80 meters) × 40.05 meters is the largest surviving mural in the Regong area, occupying the left, middle, and right walls of the hall, making it a masterpiece. The Regong murals have important historical value. On the one hand, they inherit the artistic style of the Tibetan Mantang (Miantang) school, especially the New Mantang school. The composition is full, the colors are bright, and lively. The character shapes are beautiful and delicate, and the decorative taste of mountains, rocks, trees, clouds, and other scenery is strong; On the other hand, there are also multiple methods and styles to choose from. The Tibetan Gachi School, mainland Chinese painting, and New Man Tang School painting styles appear simultaneously in one painting, reflecting the outstanding ability of Regong artists to organize and coordinate the painting and their superb technical expression skills.",
          za_introduce:
            "སྤྱི་ལོ་དུས་རབས་བཅུ་བཞི་པའི་སྔ་རྗེས་སུ་བོད་བརྒྱུད་ནང་བསྟན་དེ་ཐུན་རིན་ས་ཁུལ་དུ་དར་འགོ་ཚུགས་ཤིང་། དུས་རབས་བཅོ་ལྔ་པའི་རྗེས་སུ་ས་སྐྱ་དང་དགེ་ལུགས་པའི་གྲུབ་མཐའ་ཆེས་ཆེར་འཕེལ་རྒྱས་བྱུང་བ་དང་བསྟུན་་ནས་ས་ཁུལ་སོ་སོའི་དགོན་སྡེ་ཆེན་པོ་རྣམས་ཀྱི་བོད་རིགས་དང་ཧོར་རིགས་ཀྱི་སྐྱ་སེར་མང་པོས་སྐུ་འདྲ་བཞེངས་པ་དང་། དགོན་པར་མཛེས་བཟོ་བྱེད་པ་སོགས་དགོན་པ་བཞེངས་སྐྲུན་ཀྱི་བྱེད་སྒོར་ཞུགས། དེའི་ཕྱིར་དགོན་སྡེ་ཁག་གིས་སྤུས་ལེགས་ཀྱི་ལྡེབས་རིས་དང་། འཚེམ་དྲུབ། ཐང་ག བཟོ་བཀོད་ཚོན་རིས་སོགས་རེབ་གོང་སྒྱུ་རྩལ་བརྩམས་ཆོས་མང་པོ་ཉར་ཚགས་བྱེད་ཐུབ་པ་བྱུང་། དེའི་ནང་བཀྲ་ཤིས་དར་རྒྱས་གླིང་གི་བྱམས་ཁང་དུ་བཞུགས་པའི《གནས་བརྟན་བཅུ་དྲུག་གི་རྣམ་ཐར》ཞེས་པའི་ཆིང་རྒྱལ་རབས་སྐབས་ཀྱི་ལྡེབས་རིས(སྨི3.80×སྨི 40.05)ནི་རེབ་གོང་ས་ཁུལ་དུ་ད་ལྟའི་བར་ཉར་ཚགས་བྱས་ཡོད་པའི་ལྡེབས་རིས་བརྩམས་ཆོས་ལས་གྲགས་ཆེ་ཤོས་ཡིན་ཏེ། རི་མོ་ཧྲིལ་བོས་འདུ་ཁང་གི་གཡོན་དང་དཀྱིལ། གཡས་བཅས་ཁེབ་ཡོད། འདི་ནི་གཞི་ཁྱོན་ཆེས་ཆེ་བའི་རྩོམ་རིག་སྒྱུ་རྩལ་གྱི་་བརྩམས་ཆོས་ཤིག་རེད་ཅེས་བརྗོད་ནའང་མི་ཆོག་པ་མེད། རེབ་གོང་གི་ལྡེབས་རིས་ལ་ལོ་རྒྱུས་ཀྱི་རིན་ཐང་ཆེན་པོ་ལྡན་པ་དང་སྒྱུ་རྩལ་གྱི་རྣམ་པའི་ཐད་ཕྱོགས་གཅིག་ནས་དབུས་གཙང་གི་སྨན་ཐང་ལུགས་དང་ལྷག་པར་སྨན་ཐང་གསར་མའི་ལུགས་ཀྱི་སྒྱུ་རྩལ་གྱི་རྣམ་པ་རྒྱུན་འཛིན་བྱས་ཡོད། རི་མོའི་སྒྲིག་གཞི་ཕུན་སུམ་ཚོགས་ཤིང་། ཚོན་མདངས་རྣམ་པར་བཀྲ་ལ་མངོན་པར་གསལ། མི་སྣའི་བཟོ་དབྱིབས་དྭངས་གསལ་ཞིབ་ཚགས་ལྡན་ལ། རི་བོ་དང་ལྗོན་ཤིང་། མཚམས་སྤྲིན་སོགས་ཡུལ་ལྗོངས་ཞིབ་འབྲི་བྱས་པར་ངོ་མཚར་བའི་ཉམས་དང་ལྡན། ཕྱོགས་གཞན་ཞིག་ནས་ལེགས་ཆ་བསྡུ་ལེན་དང་རྣམ་པ་སྣ་མང་ལྡན། གཞན་དབུས་གཙང་གི་དགའ་ཁྲིའི་ལུགས་ཀྱི་རི་མོའི་རྣམ་པ་དང་རྒྱའི་རི་མོའི་རྣམ་པ། སྨན་ཐང་གསར་མའི་ལུགས་ཀྱི་རི་མོའི་རྣམ་པ་སོགས་དུས་གཅིག་ཏུ་རི་མོ་གཅིག་ལས་མངོན་པ་ལས་རེབ་གོང་སྒྱུ་རྩལ་གྱི་ཁྱད་མཚར་བའི་པར་ངོས་སྙོམས་སྒྲིག་དང་ལག་རྩལ་གྱི་ཁྱད་ཆོས་མཚོན་ཡོད།",
          introduce:
            "公元十四世纪前后，藏传佛教开始在同仁地区流传，至十五世纪以后，随着萨迦派，继而格鲁派[黄教]的迅猛发展，各地区大兴寺院，遂使大量藏族、土族僧俗投入到绘塑佛像、装饰寺庙的活动中，因此各个寺院也保存了大量的精美的壁画、堆绣、唐卡、建筑彩绘等热贡艺术作品。其中年都乎寺弥勒殿《十六罗汉传》清代壁画（3．80米×40．05米）是热贡地区现存最大的壁画作品，整个画面占据殿堂的左、中、右三面墙壁，可谓鸿篇巨制。热贡壁画具有重要的历史价值，在艺术风格上一方面继承了西藏曼唐（勉唐）派特别是新曼唐派的艺术风格，构图饱满、色彩艳丽、明快，人物造型清秀、细腻，山石、树木、云霞等景物装饰味浓厚；另一方面也多方取法、风格多样，西藏噶赤派画风、内地画风、新曼唐派画风同时出现在一幅画面中，体现出热贡艺人出众的画面组织协调才能和高超的技法表现功底。",
          worksImages: [
            {
              imgSrc: require("../assets/newImage/index/bihua01.png"),
              name: "壁画（拍摄于年都乎寺）",
              za_name: "ལྡེབས་རིས།",
              eng_name: "mural(Takne at Nianduhu Temple)",
            },
            {
              imgSrc: require("../assets//newImage/index/bihua02.png"),
              name: "壁画（拍摄自年都乎寺）",
              za_name: "ལྡེབས་རིས།",
              eng_name: "mural(Taken at Nianduhu Temple)",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
        {
          title: "热贡彩绘",
          za_title: " ར་གོང་ཚོན་རིས།",
          eng_title: "Regong Paintings",
          eng_introduce:
            "Color painting is a decorative art that exists attached to buildings, indoor furnishings, and daily utensils. It is commonly found in buildings of Buddhist temples and is often used for portraits, books, murals, wall skirts, doors and windows, column decorations, caissons, painted beams and carved buildings, etc. This type of pattern is well proportioned, clear, elegant, and solemn, appearing in square, circular, or other geometric shapes. By using different colors and expressive techniques, as well as techniques such as density, concentration, curvature, length, and size, the same flower shape can produce various forms, forming a rich and colorful pattern.",
          za_introduce:
            "ཚོན་རིས་ནི་རྩིག་བཟོའི་དངོས་པོ་དང་། ཁང་པའི་ནང་གི་སྒྲིག་ཆས། རྒྱུན་གཏན་གྱི་ཡོ་བྱད་བཅས་ལ་རྒྱན་སྤྲས་བྱེད་པའི་སྒྱུ་རྩལ་ཞིག་ཡིན་ཞིང་མང་ཆེ་བ་དགོན་པའི་བཟོ་སྐྲུན་དུ་མཐོང། དེ་དག་གཙོ་བོ་རི་མོ་དང་། དཔེ་དེབ། ལྡེབས་རིས། རྩིགས་པ། སྒོ་དང་སྒེའུ་ཁུང་། ཀ་པའི་རྒྱན་ཆ། གནམ་གཅལ། གདུང་མའི་བརྐོས་རིས་སོགས་ལ་བཀོལ་སྤྱོད་བྱེད་ཀྱིན་ཡོད། རི་མོ་འདིའི་རིགས་བྲིས་པ་དོ་མཉམ་ལ་གསལ་བ། བབས་ཆགས་ཤིང་བརྗིད་པ། རྣམ་པའི་ཐད་ནས་གྲུ་བཞི་དང་། སྒོར་དབྱིབས་སམ་ཡང་ན་དབྱིབས་ཀྱི་རྣམ་པ་གཞན་ཡང་ཡོད། ཡང་ཁ་དོག་དང་མཚོན་ཐབས། མང་ཉུང། འདུས་འཐོར། དྲང་འཁྱོག ། རིང་ཐུང་། ཆེ་ཆུང་སོགས་མི་འདྲ་བར་གཞིགས་ནས་འགྱུར་ལྡོག་བཏང་ཡོད། མེ་ཏོག་གི་དབྱིབས་རིས་གཅིག་ལ་རྣམ་པ་འདྲ་མིན་སྣ་ཚོགས་འབྱུང་སྟེ། དེས་སྣ་མང་ཕུན་སུམ་ཚོགས་པའི་རི་མོ་གྲུབ་པ་ཡོད།",
          introduce:
            "彩绘是依附于建筑物、室内摆设、日常用具而存在的装饰艺术，多见于佛教寺院的建筑物，多用于画像、书籍、壁画、墙裙、门窗、柱饰、藻井、画梁雕栋等。这类图案画匀称、清晰、典雅、庄重，呈方形、圆形或者其他几何图形。再运用色彩和表现手法的不同，以及疏密、聚散、曲直、长短、大小等手法来进行变化，同一花形可以产生多种多样的形式，构成丰富多彩的图案。",
          worksImages: [
            {
              imgSrc: require("../assets/newImage/index/caihui01.png"),
              name: "彩绘（卷草纹）",
              za_name: "ཚོན་བྲིས།",
              eng_name: "Painting(Rolled grass pattern)",
            },
            {
              imgSrc: require("../assets/newImage/index/caihui02.png"),
              name: "建筑彩绘（拍摄自吾屯上寺）",
              za_name: "ཚོན་བྲིས་བརྐོས་པ།",
              eng_name: "Architectural Painting(Taken from Wutunshang Temple)",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
        {
          title: "更多",
          eng_title: "More",
          za_title: "དེ་ལས་མང་བ།",
          za_introduce:
            "རེབ་གོང་སྒྱུ་རྩལ་ནི་བོད་བརྒྱུད་ནང་བསྟན་སྒྱུ་རྩལ་གྱི་གྲུབ་ཆ་གལ་ཆེན་དང་ཤུགས་རྐྱེན་ཤིན་ཏུ་ཆེ་བའི་སྒྱུ་རྩལ་གྱི་རྣམ་པ་ཞིག་ཡིན། ལོ་ངོ་བརྒྱ་ཕྲག་དུ་མའི་རིང་རེབ་གོང་གི་སྒྱུ་རྩལ་པ་མང་པོས་དམངས་ཁྲོད་ཀྱི་ནང་བསྟན་འཇིམ་བཟོའི་ལས་ལ་གཞོལ་ཞིང་། རེབ་གོང་སྒྱུ་རྩལ་གྱི་ལག་རྩལ་མཐར་སོན་པའི་སྒྱུ་རྩལ་པ་མང་པོ་གསོ་སྐྱོང་བྱས་པ་དེ་འདྲ་ནི་བོད་ཁུལ་གྱི་ས་ཆ་གཞན་པར་མཐོང་དཀོན། དེའི་སྟབས་ཀྱིས་གནས་འདིར་བོད་ཀྱི་ལྷ་རིས་སྒྱུ་རྩལ་གྱི་ཕ་ས་ཞེས་པའི་མཚན་སྙན་ཀྱང་ཐོབ། དེར་མ་ཟད་ཐུན་རིན་ས་ཁུལ་ལ་བོད་སྐད་དུ'རེབ་གོང'ཞེས་འབོད་པས། སྒྱུ་རྩལ་གྱི་རྣམ་གྲངས་འདིར་རེབ་གོང་སྒྱུ་རྩལ་ཡང་ཟེར། རེབ་གོང་སྒྱུ་རྩལ་ལ་གཙོ་བོར་ཐང་ག་དང་། འཚེམ་དྲུབ། འཇིམ་སྐུ། ལྡེབས་རིས། རྩིག་བཟོའི་ཚོན་རིས་སོགས་ཡོད། ས་གནས་དེ་གའི་སྒྱུ་རྩལ་པ་དང་རྒྱུན་འཛིན་པ་རྣམས་ནས་ཡུན་རིང་གི་རྒྱུན་འཛིན་དང་གསར་གཏོད་ཀྱི་འགྲོས་དང་བསྟུན་ནས། རྡོ་བརྐོས་དང་། ཟངས་བརྐོས། ཤིང་བརྐོས་སོགས་རེབ་གོང་རིག་གནས་གསར་གཏོད་ཀྱི་རྣམ་པ་གསར་པའང་མང་དུ་གྲུབ་ཏེ་ཐོག་མཐའ་བར་གསུམ་དུ་གསོན་ཤུགས་ཀྱིས་ཁེངས་ཡོད།",
          eng_introduce:
            "Regong art is an important part of Tibetan Buddhism art and an art school with wide influence. For hundreds of years, there have been a large number of artists here engaged in folk Buddhist painting and sculpture art. Their numerous practitioners and exquisite group skills are rare in other Tibetan areas, so they are known as the 'hometown of Tibetan painters'. Tongren region is called 'Regong' in Tibetan, so this art is collectively referred to as 'Regong art'. Regong art focuses on Thangka, heap embroidery, clay sculpture, murals, and architectural painting. With the inheritance and innovation of local artists and inheritors from generation to generation, there are more newer art forms such as stone carving, bronze carving, wood carving, Regong cultural innovation, and New China-Chic, which are always full of vitality.",
          introduce:
            "热贡艺术是藏传佛教艺术的重要组成部分和颇具广泛影响的艺术流派。数百年来，这里有大批艺人从事民间佛教绘塑艺术，其从艺人员之众多、群体技艺之精到，都为其它藏区所少见，故被誉为“藏族画家之乡”，而同仁地区在藏语中称为“热贡”，因此这一艺术便统称为“热贡艺术”。热贡艺术以唐卡、堆绣、泥塑、壁画、建筑彩绘为主，随着当地艺术家、传承人的代代传承和创新，也有着石雕、铜雕、木雕、热贡文创、新国潮等更多更新的艺术形态，始终焕发着勃勃生机。",
          worksImages: [
            {
              imgSrc: require("../assets/indexImage/T1.jpg"),
              name: "四臂观音石刻",
              za_name: "སྤྱན་རས་གཟིགས་ཕྱག་བཞི་བའི་བྲག་བརྐོས།",
              eng_name: "SiBiGuanYin ShiKe",
            },
            {
              imgSrc: require("../assets/indexImage/T2.jpg"),
              name: "大藏经石刻",
              za_name: "བཀའ་འགྱུར་གྱི་བྲིས་གཟུགས",
              eng_name: "DaCangJing ShiKe",
            },
          ],
          videoList: [
            {
              imgSrc: require("../assets/videos/tang_1.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_2.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_3.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_4.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_5.mp4"),
            },
            {
              imgSrc: require("../assets/videos/tang_6.mp4"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    onTabClick(index) {
      this.selectedIndex = index;
      let messageItem = this.MessagesList[index];
      this.$emit("getIndex", messageItem);
    },
  },
  created() {
    this.onTabClick(0);
  },
  mounted() {
    new this.$wow.WOW().init();
  },
};
</script>
<style lang="scss">
.eng-tab-container {
  margin-bottom: 60px;
}
.tab-container {
  .tabs {
    display: flex;
    justify-content: flex-end;
    .tab-item {
      font-family: "fangzang";
      font-size: 30px;
      margin-left: 20px;
      letter-spacing: 4px;
      padding-bottom: 4px;
      cursor: pointer;
    }
    .tab-items {
      // writing-mode: tb-rl;
      // text-orientation: upright;
      // >div {
      //   margin: 0 auto;
      //   width: 30px;
      //   font-size: 30px;
      // }
    }
    .za_tab-item { 
      font-size: 24px;
      max-width: 120px;
      margin-right: 15px;
      border-bottom: 4px solid transparent;
    }
    .eng_tab-item-pc {
      text-align: start;
      width: 50px;
      padding-left: 10px;
      font-size: 24px;
      transform:rotate(90deg);
      -ms-transform:rotate(90deg); 	/* IE 9 */
      -moz-transform:rotate(90deg); 	/* Firefox */
      -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
      -o-transform:rotate(90deg); 	/* Opera */
      white-space: nowrap;
      // border-right: 4px solid transparent;
      padding-left:10px ;
      border-bottom: none;
    }
    .engselected {
      color: #ed201a;
      border-left: 4px solid #ed201a;
      padding-left:6px ;
    }
    .zangselected {
      color: #ed201a;
      border-bottom: 4px solid #ed201a;
      // padding-right:6px ;
    }
    .eng_tab-item {
      font-family: "Times New Roman", Times, serif;
      // width: 64px!important;
      // word-wrap:break-word; 
      // word-break:break-all;
    }
    .selected {
      color: #ed201a;
      border-bottom: 4px solid #ed201a;
    }
  }
  .zang_tabs {
    // padding-top: 10px;
    cursor: pointer;
  }
  .engLish_tabs {
    // padding: 50px 0;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
  .tab-container {
    .mobile_tabs {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eeeff0;
      align-items: center;
      justify-content: center;
      .tab-item {
        letter-spacing: 2px;
        white-space: normal;
        text-align: center;
        cursor: pointer;
        height: 56px;
        line-height: 26px;
      }
      .cn_tab-item {
        margin-right: 0.3rem;
        font-size: 0.4rem;
        font-family: 'fangzang';
      }
      .za_tab-item {
        font-size: 0.3rem;
        margin-right: .15rem;
      }
      .eng_tab-item {
        font-size: 0.24rem;
        margin-right: .08rem;
      }
      .eng_tab-item-mobile {
        // word-break: break-all;
        font-size: 0.2rem;
      }
      .za_tab-item-mobile {
        font-size: 0.24rem;
      }
      .selected {
        padding-bottom: 0.4rem;
        color: #ed201a;
        border-bottom: 3px solid #ed201a;
      }
    }
  }
}
</style>
